export default __webpack_public_path__ + "static/media/Anne-Sophie.bb683fdd.jpg";